import { gql } from "@apollo/client";
import { gl } from "date-fns/locale";


export const GET_PUBLIC_FORUM_PAGINATION = gql`
  query GetPublicForumPagination($page: Int, $limit: Int, $keyword: String, $pagination: Boolean, $districtMunicipalityId: ID) {
  getPublicForumPagination(page: $page, limit: $limit, keyword: $keyword, pagination: $pagination, districtMunicipalityId: $districtMunicipalityId) {
    data {
      _id
      districtMunicipalityId {
        _id
        district_municipality_name_en
        district_municipality_name_kh
      }
      publicForumTitle
      publicForumDescription
      startDate
      endDate
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

export const GET_QUESTION_AND_ANSWER_WITH_PAGINATION = gql`
query GetQuestionAnswerPublicForumPagination($page: Int, $limit: Int, $keyword: String, $pagination: Boolean, $publicForumId: String) {
  getQuestionAnswerPublicForumPagination(page: $page, limit: $limit, keyword: $keyword, pagination: $pagination, publicForumId: $publicForumId) {
    data {
      _id
      workGroupId {
        _id
        numbering
        work_group_name
      }
      questionType
      asker
      communeSangkatId {
        _id
        commune_sangkat_name_kh
        commune_sangkat_name_en
      }
      villageId {
        _id
        village_name_kh
        village_name_en
      }
      question
      answer
      conclusion
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

export const GET_PUBLIC_FORUM_BY_ID = gql`
query GetPublicForumById($id: ID!) {
  getPublicForumById(_id: $id) {
    _id
    publicForumTitle
    districtMunicipalityId {
      _id
      district_municipality_name_kh
      district_municipality_name_en
    }
  }
}
`;

export const CREATE_PUBLIC_FORUM = gql`
mutation CreatePublicForum($input: PublicForumInput) {
  createPublicForum(input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;



export const UPDATE_PUBLIC_FORUM = gql`
mutation UpdatePublicForum($id: ID!, $input: PublicForumInput) {
  updatePublicForum(_id: $id, input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;

export const DELETE_PUBLIC_FORUM = gql`
  mutation DeletePublicForum($id: ID!) {
    deletePublicForum(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_QUESTION_AND_ANSWER = gql`
mutation CreateQuestionAnswerPublicForum($input: QuestionAndAnswerPublicForumCreateInput) {
  createQuestionAnswerPublicForum(input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;
export const UPDATE_QUESTION_AND_ANSWER = gql`
mutation UpdateQuestionAnswerPublicForum($id: ID!, $input: QuestionAndAnswerPublicForumUpdateInput) {
  updateQuestionAnswerPublicForum(_id: $id, input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;

export const DELETE_QUESTION_AND_ANSWER = gql`
mutation DeleteQuestionAnswerPublicForum($id: ID!) {
  deleteQuestionAnswerPublicForum(_id: $id) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;